import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoOrigemMultiSelectComponent } from './novo-origem-multi-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoOrigemMultiSelectComponent],
  exports: [NovoOrigemMultiSelectComponent]
})
export class NovoOrigemMultiSelectModule {}
